// スムーススクロール
import { smoothScroll } from "./lib/smooth-scroll";
smoothScroll();
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

// ページ読み込み時のアンカー位置補正
import { anchorOffset } from "./lib/anchor-offset";
anchorOffset();

// スクロールトップ
import { scrollTop } from "./lib/scroll-top";
scrollTop();

// インビュー
import { inview } from "./lib/inview";
inview();

// ドロワーメニュー
import { drawer } from "./lib/drawer";
drawer();

// モーダルウィンドウ
import { modal } from "./lib/modal";
modal();

// アコーディオン
import { accordion } from "./lib/accordion";
accordion();

// カレント表示
import { currentMenu } from "./lib/current-menu";
currentMenu();

// Online Shop Button 追従
// import { onlineshopButtonFixed } from "./lib/online-shop-button";
// onlineshopButtonFixed();

/* =================================================================

  jsが使用可能の場合classを付与

================================================================= */

document.documentElement.classList.add("is-jsEnable");

/* =================================================================

  画面幅からはみ出た要素をJavaScriptで検出する

================================================================= */

// document.querySelectorAll("*").forEach((el) => (el.clientWidth > document.body.clientWidth ? console.log(el) : null));

/* =================================================================

  読み込みが完了したらclassを付与

================================================================= */

const load = function () {
  window.addEventListener("load", () => {
    document.documentElement.classList.add("is-loaded");
    setTimeout(function () {
      document.documentElement.classList.add("is-start");
      // setTimeout(function () {
      //   document.documentElement.classList.add("is-over");
      // }, 1000);
    }, 2000);
  });
};
load();

/* =================================================================

  スクロールバーの横幅を計算

================================================================= */

const setScrollbarWidth = () => {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  // カスタムプロパティの値を更新する
  document.documentElement.style.setProperty("--scrollbar", `${scrollbarWidth}px`);
};

// 表示されたとき
window.addEventListener("load", setScrollbarWidth);
// リサイズしたとき
window.addEventListener("resize", setScrollbarWidth);

/* =================================================================

    header変形

================================================================= */

//スクロール時のイベントを追加
window.addEventListener("scroll", () => {
  const headerAnimation = document.querySelector(".js-header");
  if (headerAnimation) {
    if (window.scrollY > 0) {
      headerAnimation.classList.add("is-animation");
    } else if (window.scrollY < 1) {
      headerAnimation.classList.remove("is-animation");
    }
  }
});

/* =================================================================

  別ページからのリンク

================================================================= */

window.addEventListener("load", () => {
  const headerHeight = document.querySelector(".js-header").clientHeight;
  const urlHash = location.hash;

  if (urlHash) {
    const targetTop = document.querySelector(urlHash).getBoundingClientRect().top + window.pageYOffset;
    const position = targetTop - headerHeight;

    window.scrollTo({
      top: position,
      // behavior: "smooth",
    });
  }
});

/* =================================================================

  フォーム

================================================================= */

// 確認画面から戻る際に値を保持する
const formBack = function () {
  const backButton = document.querySelector(".js-back");

  if (backButton) {
    backButton.addEventListener("click", () => {
      const formElement = document.getElementById("form");
      formElement.setAttribute("action", formElement.getAttribute("action").replace("complete", "form#form"));

      // input[mode] を書き換え
      document.querySelector("input[name=mode]").setAttribute("value", "");
    });
  }
};
formBack();

// セレクトボックスの初期値
function updateSelectOptions() {
  // ターゲットとなるoptionを取得
  var options = document.querySelectorAll('.mw_wp_form_input select option[value=""]');

  options.forEach(function (option) {
    // 親要素（selectタグ）のname属性を取得
    var selectName = option.parentElement.getAttribute("name");

    // name属性の値によって文言を変更
    if (selectName === "pref") {
      option.innerHTML = "都道府県を選択してください";
    } else if (selectName === "recognition") {
      option.innerHTML = "Please select how you learned about us.";
    } else {
      // それ以外（デフォルト）
      option.innerHTML = "選択してください";
    }
  });
}

document.addEventListener("DOMContentLoaded", updateSelectOptions);

// .js-zip-searchが存在する場合にのみイベントリスナーを追加
const zipInput = document.querySelector(".js-zip-search");

if (zipInput) {
  zipInput.addEventListener("keyup", function () {
    const zip = zipInput.value.replace(/[^0-9]/g, ""); // 数字のみ取得

    // 郵便番号が7桁になったら検索実行
    if (zip.length === 7) {
      AjaxZip3.zip2addr("zip", "", "pref", "address");

      // 失敗時の処理
      AjaxZip3.onFailure = function () {
        alert("郵便番号に該当する住所が見つかりません");
      };
    }
  });
}

/* =================================================================

  サイドメニュー高さ取得

================================================================= */

// const myFunc = () => {
//   let elem = document.querySelector(".js-side");
//   let sideHeight = elem.offsetHeight;
//   elem.style.height = sideHeight + "px";
// };

// window.addEventListener("load", myFunc, true);
// window.addEventListener("resize", myFunc, true);

/* =================================================================

  「個人情報保護方針に同意する」にチェックで有効

================================================================= */

function checkFlag() {
  const enabled = document.querySelector(".js-submit-button");
  const consent = document.querySelector(".js-consent");

  if (enabled || consent) {
    if (consent.checked) {
      enabled.classList.add("is-enabled");
    }
    consent.addEventListener("click", () => {
      if (consent.checked) {
        enabled.classList.add("is-enabled");
      } else {
        enabled.classList.remove("is-enabled");
      }
    });
  }
}
checkFlag();

/* =================================================================

  コンテンツをもっと見る・閉じるで開閉

================================================================= */
const readmore = document.querySelectorAll(".js-readMoreInner");

Array.from(readmore).forEach(function (more) {
  const btn = more.querySelector(".js-readMoreBtn");
  const btnText = more.querySelector(".js-readMoreBtn .text");
  const content = more.querySelector(".js-readMoreContainer");

  // ボタンクリックでイベント処理
  btn.addEventListener("click", () => {
    if (!content.classList.contains("is-show")) {
      content.style.maxHeight = content.scrollHeight + "px";
      content.classList.add("is-show");
      btn.classList.add("is-show");
      btnText.innerText = "閉じる";
    } else {
      content.style.maxHeight = "400px";
      content.classList.remove("is-show");
      btn.classList.remove("is-show");
      btnText.innerText = "もっと見る";
    }
  });
});

/* =================================================================

  venobox

================================================================= */
import VenoBox from "venobox";
new VenoBox({
  selector: ".js-venobox",
  spinner: "bounce",
  spinColor: "#968B7C",
  overlayColor: "rgba(0,0,0,0.6)",
  arrowsColor: "#968B7C",
  infinigall: true,
});

// Initialize venobox as a variable
const venobox = new VenoBox();

venobox.close(); // Close the modal window
venobox.next(); // Navigate the next gallery item
venobox.prev(); // Navigate the previous gallery item

// Open specific item
var myClose = document.querySelectorAll(".js-venobox-close");
venobox.close(myClose);

// カスタム閉じるボタンのクリックイベントを設定
// document.addEventListener("DOMContentLoaded", () => {
//   const closeBtn = document.querySelector(".js-venobox-close");
//   if (closeBtn) {
//     closeBtn.addEventListener("click", () => {
//       venobox.close();
//     });
//   }
// });

/* =================================================================

  swiper

================================================================= */
// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";

// import styles bundle
// import "swiper/css/bundle";

const productSlider = new Swiper(".js-product-slider", {
  effect: "slide",
  speed: 3000,
  autoplay: {
    delay: 8000,
    disableOnInteraction: false,
    waitForTransition: false,
    // reverseDirection: false,
  },
  // autoplayDisableOnInteraction: false,
  loop: true,
  // centeredSlides: false,
  slidesPerView: 1,
  // allowTouchMove: true,
  // slideToClickedSlide: true,
  // loopAdditionalSlides: 1,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

/*
  TOP service スライダー
--------------------------------- */

const serviceSlider = new Swiper(".js-service-slider", {
  // --- スマホ（基本）の設定 ---
  effect: "slide", // "slider"ではなく"slide"が正しい値です
  speed: 2000,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  loop: true,
  spaceBetween: 32,
  slidesPerView: 1,

  // DOMの変化や親要素のサイズ変化を監視してSwiperを更新する設定
  observer: true,
  observeParents: true,

  // --- PC（特定幅以上）の設定 ---
  breakpoints: {
    1024: {
      enabled: false, // Swiperを無効化（動かなくする）
      loop: false, // ループも解除（重複スライドの生成を防ぐため）
      spaceBetween: 0,
    },
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

/*
 サービスのナビゲーション
--------------------------------- */

const serviceSwiper = new Swiper(".p-service-nav", {
  slidesPerView: 1,
  spaceBetween: 8, // 行間・列間の隙間

  grid: {
    rows: 3, // 【修正】ここを3から4に変更
    fill: "column",
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  breakpoints: {
    744: {
      enabled: false,
      slidesPerView: "auto",
      spaceBetween: 0,
      grid: {
        rows: 1,
      },
    },
  },
});
